<div class="discover">

  <!-- ============ HERO STRIP ============ -->
  <div class="hero-strip" style="display: none;">
    <div class="hero-card featured">
      <div class="ls-eyebrow"><span class="dot"></span>En tête cette semaine</div>
      <h2>Mèsi Senyè — 605 K écoutes,<br/>un sommet de la louange krèyol.</h2>
      <p class="sub">Le single de Marie-Jean Pierre s'installe pour la 3<sup>e</sup> semaine consécutive en tête du chart krèyol. Texte de gratitude, mélodie en D, refrain mémorable.</p>
      <div class="row">
        <div class="art"></div>
        <div class="body">
          <div class="ti">Mèsi Senyè</div>
          <div class="ar">Marie-Jean · MJF 124 · 2:55</div>
        </div>
        <a class="cta" [routerLink]="['/', lang(), 'Discover']">
          Lire le chant
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
        </a>
      </div>
    </div>

    <div class="hero-card editorial">
      <div class="ls-eyebrow">Sélection éditoriale</div>
      <h2 class="h2-sm">Avent 2026 : 28 chants pour préparer Noël.</h2>
      <p class="sub sm">Quatre semaines, quatre thématiques — Espérance, Paix, Joie, Amour.</p>
      <div class="row">
        <div class="art a4"></div>
        <div class="body">
          <div class="ti">Avent · 4 semaines</div>
          <div class="ar">par <b>&#64;equipe-editoriale</b></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ VERSET DU JOUR ============ -->
  <section class="verse-strip" style="display: none;">
    <div class="verse-side">
      <div class="ls-eyebrow">
        <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
        Verset du jour · 18 mai 2026
      </div>
      <blockquote><span class="open-q">"</span>Que tout ce qui respire loue l'Éternel ! Louez l'Éternel !"</blockquote>
      <cite>Psaume 150 : 6</cite>
      <div class="verse-link">
        <div>
          <div class="label">Chant lié</div>
          <a [routerLink]="['/', lang(), 'Discover']">
            Que tout ce qui respire · CEF 178
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </a>
        </div>
      </div>
    </div>
    <div class="verse-aside">
      <div class="ref-label">Méditation · louange</div>
      <h3>Que tout ce qui respire</h3>
      <div class="art-meta">Choral CEF · Français · 4:12</div>
    </div>
  </section>

  <!-- ============ ARTISTES POPULAIRES ============ -->
  <ls-artists-section />

  <!-- ============ PLAYLISTS PUBLIQUES ============ -->
  <ls-public-playlists-section [tinted]="true" (hasItems)="hasPublicPlaylists.set($event)" />

  <!-- ============ CHARTS ============ -->
  <app-lyric-list-band mode="popular" />

  <!-- ============ NOUVEAUTÉS ============ -->
  <app-lyric-list-band mode="latest" [tinted]="true" />

  <!-- ============ ALBUMS PUBLICS ============ -->
  <ls-public-albums-section (hasItems)="hasPublicAlbums.set($event)" />

  <!-- ============ PAR GENRE ============ -->
  <!-- L'alternance blanc / teinté se décale quand la rubrique playlists ou la rubrique albums est absente. -->
  <ls-genres-section [genres]="genres" [tinted]="!hasPublicPlaylists() !== hasPublicAlbums()" />

  <!-- ============ HYMNES DU DOMAINE PUBLIC ============ -->
  <ls-section-band [tinted]="true">
  <section class="hymnes-strip">
    <div class="inner">
      <div class="left">
        <div class="ls-eyebrow">Patrimoine · sans enregistrement</div>
        <h2>Les hymnes qu'on chante sans piste audio.</h2>
        <p class="desc">Quatre siècles de cantiques transmis de chœur en chœur. Paroles, partition, accords — pas besoin d'un studio pour les faire vivre.</p>
      </div>
      <div class="right">
        @for (h of hymnes; track h.ref) {
          <a class="hymne" [routerLink]="['/', lang(), 'search']" [queryParams]="{ q: h.title }">
            <div class="ref">{{ h.ref }}</div>
            <div class="ti">{{ h.title }}</div>
            <div class="ye">{{ h.year }}</div>
          </a>
        }
      </div>
    </div>
  </section>
  </ls-section-band>

  <!-- ============ SÉLECTIONS ÉDITORIALES ============ -->
  <ls-section-band>
  <section class="zone" style="display: none;">
    <div class="zone-h">
      <div class="left">
        <div class="ls-eyebrow">Sélections éditoriales</div>
        <h2>Préparées par notre équipe</h2>
        <div class="meta">Mises à jour chaque mois · disponibles hors ligne (Premium)</div>
      </div>
    </div>
    <div class="selections">
      @for (s of selections; track s.title) {
        <a class="selection">
          <div class="vis">
            <div class="grid-art"><div></div><div></div><div></div><div></div></div>
            <span class="label">{{ s.label }}</span>
            <span class="count">{{ s.count }}</span>
          </div>
          <div class="body">
            <h3>{{ s.title }}</h3>
            <p class="desc">{{ s.desc }}</p>
            <div class="curator">
              <span class="av" [style]="s.curatorStyle">{{ s.curatorAv }}</span>
              par <b>{{ s.curator }}</b>
            </div>
          </div>
        </a>
      }
    </div>
  </section>
  </ls-section-band>

  <!-- ============ RECUEILS ============ -->
  <ls-section-band [tinted]="hasPublicPlaylists() !== hasPublicAlbums()">
  <section class="zone">
    <div class="zone-h">
      <div class="left">
        <div class="ls-eyebrow">Recueils</div>
        <h2>Continue ton parcours</h2>
        <div class="meta">Reprends là où tu t'es arrêté</div>
      </div>
      <a class="more" [routerLink]="publicRoute(routeName.Recueils)">Tous les recueils →</a>
    </div>
    <ls-recueil-grid [recueils]="recueils()" />
  </section>
  </ls-section-band>

</div>
